export const ASOCOINS_SOURCE_LABELS = Object.freeze({
  MANUAL_ASSIGNMENT: "Asignación manual",
  MANUAL_ADJUSTMENT: "Ajuste manual",
  MONTHLY_LOGIN: "Acceso mensual a intranet",
  MEMBERSHIP_RENEWAL: "Renovación de membresía",
  EVENT_PAYMENT: "Compra de evento",
  PRODUCT_PAYMENT: "Compra de producto o servicio",
  ORDER_PAYMENT: "Pago con Asocoins",
  ORDER_ASOCOINS: "Pago con Asocoins",
  SURVEY_RESPONSE: "Respuesta a encuesta",
  EXPIRATION: "Caducidad de Asocoins",
  EVENT_CONVENTION: "Convención Nacional",
  COURSE_PAID: "Cursos pagados",
  REGIONAL_MEETING: "Encuentros regionales",
  NETWORKING: "Networking",
  WORKSHOP: "Talleres",
  FREE_COURSE: "Cursos gratuitos",
  WEBINAR: "Webinars",
  MEMBERSHIP_EARLY: "Renovación anticipada",
  MEMBERSHIP_ON_TIME: "Renovación a tiempo",
  MEMBERSHIP_LATE: "Renovación vencida",
  INTRANET_LOGIN: "Uso mensual de intranet",
  SURVEY: "Encuesta institucional",
  SAC_N3_HR: "Certificación SAC N3 + HR",
  SAC_N3: "Certificación SAC N3",
  SAC_N2_N1: "Certificación SAC N2/N1",
  SAC_NE: "Certificación SAC NE",
  REFERRAL_SOFOM: "Referir nueva SOFOM",
  BENCHMARK: "Benchmark",
  SPECIALIST_ADVISORY: "Asesoría de consultor especialista",
  COMMITTEE_PROJECT: "Participación en proyectos de comités",
  COMMITTEE_PRESIDENT: "Presidentes de comités y regionales",
  SOCIAL_DYNAMIC: "Dinámicas en redes sociales",
  APP_AGENDA: "Registro de agenda de la app ASOFOM",
});

export const ASOCOINS_SOURCE_OPTIONS = Object.entries(ASOCOINS_SOURCE_LABELS)
  .map(([value, label]) => ({ value, label }))
  .sort((left, right) => left.label.localeCompare(right.label, "es"));

const ASOCOINS_TYPE_LABELS = Object.freeze({
  CREDIT: "Abono",
  DEBIT: "Cargo",
  PENALTY: "Penalización",
  EXPIRATION: "Caducidad",
  ADJUSTMENT: "Ajuste",
});

export const getAsocoinsSourceLabel = (source) =>
  ASOCOINS_SOURCE_LABELS[source] || (source ? "Otro origen" : "—");

export const getAsocoinsTypeLabel = (type) => ASOCOINS_TYPE_LABELS[type] || type || "—";
